import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import _ from "lodash";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import settings from "./settings.js";
import ClientBadge from "./components/ClientBadge.js";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      data: [],
      searchString: "",
      modal: false,
      selectedNews: null,
      newsDetails: null,
      clients: [],
      filterClientID: 0,
    };

    // Create debounced search function
    this.debouncedLoadData = _.debounce(this.loadData, 500);
  }
  UNSAFE_componentWillMount() {
    this.props.authenticate("/");
  }

  componentDidMount() {
    if (this.props.isSalesRep) {
      this.props.history.push("/hotels");
    } else {
      this.loadData();
      this.props.searchHandler2("");
      this.props.setSearchClient(0);
      this.props.closeMenu();
      this.props.addBreadcrumb([
        { name: "Nieuws", url: "/nieuws", reset: true },
      ]);
    }
  }

  componentDidUpdate() {
    if (this.props.isSalesRep) {
      this.props.history.push("/hotels");
      return null;
    }
  }
  loadData() {
    this.setState({ isLoading: true });
    const params = {
      ...(this.state.filterClientID &&
        this.state.filterClientID !== "0" && {
          client: this.state.filterClientID,
        }),
    };
    fetch(
      settings.server_url +
        "get_newsitems/" +
        window.sessionStorage.getItem("sid"),
      {
        method: "POST",
        body: JSON.stringify({
          showAll: true,
          search: this.state.searchString,
          ...params,
        }),
      }
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ data: response, isLoading: false });
      })
      .catch((error) => console.error("Error:", error));
  }

  decodeHtmlEntities(txt = "") {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = txt;
    return textarea.value;
  }
  createMarkup(txt) {
    return { __html: this.decodeHtmlEntities(txt || "") };
  }
  clickRemove = (newsID) => {
    fetch(
      settings.server_url +
        "set_newsitem_read/" +
        window.sessionStorage.getItem("sid") +
        "/" +
        newsID
    )
      .then((res) => res.json())
      .then((response) => {})
      .catch((error) => console.error("Error:", error))
      .finally(() => this.loadData());
  };

  handleSearchChange = (e) => {
    this.setState({ searchString: e.target.value }, () => {
      this.debouncedLoadData();
    });
  };

  loadNewsDetails(newsId) {
    this.setState({ newsDetails: null });
    fetch(
      settings.server_url +
        "get_newsitem/" +
        window.sessionStorage.getItem("sid") +
        "/" +
        newsId
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ newsDetails: response });
      })
      .catch((error) => console.error("Error:", error));
  }

  toggle = (notification = null) => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
      selectedNews: notification,
    }));
  };

  handleNewsClick = (notification) => {
    this.loadNewsDetails(notification.nieuws_id);
    this.toggle(notification);
  };

  handleClientChange = (e) => {
    const clientId = e.target.value;
    this.setState({ filterClientID: clientId }, () => {
      // Herlaad de huidige pagina met de nieuwe client filter
      this.loadData();
    });
  };

  render() {
    if (!this.props.isAuthenticated) return null;

    return (
      <Scrollbars
        renderView={this.renderView}
        renderThumbHorizontal={this.renderThumb}
        renderThumbVertical={this.renderThumb}
        onUpdate={this.handleUpdate}
        className="row ml-0 content-bc">
        <div className="col p-md-4 px-0 maxw1200">
          <div className="newsContainer">
            <div className="col">
              <div className="newsHeader">
                <div className="newsHeaderTitle">Nieuws</div>
                <div className="newsHeaderSearch">
                  <div className="newsHeaderSearchSelect">
                    <div className="form-label">Toon</div>
                    <select
                      className="form-control"
                      onChange={this.handleClientChange}
                      value={this.state.filterClientID}>
                      <option value="0">Alle afdelingen</option>
                      <option value="10">Van der Valk Koel & Vries</option>
                      <option value="11">Van der Valk Centraal Magazijn</option>
                      <option value="54">Van der Valk Dagvers</option>
                      <option value="69">Van der Valk Versmarkt</option>
                      <option value="29">Van der Valk Apparaten</option>
                      <option value="61">Van der Valk Vis</option>
                      <option value="120">Valk en Vlees</option>
                    </select>
                  </div>
                  <input
                    type="text"
                    placeholder="Zoeken"
                    className="form-control"
                    value={this.state.searchString}
                    onChange={this.handleSearchChange}
                  />
                </div>
              </div>
            </div>
            <div className="">
              {this.state.data.map((notification, index) => {
                let nieuwsDate = new Date(notification.nieuws_date);
                let edd = nieuwsDate.getDate();
                let emm = nieuwsDate.getMonth() + 1;
                let eyyyy = nieuwsDate.getFullYear();
                if (edd < 10) {
                  edd = "0" + edd;
                }
                if (emm < 10) {
                  emm = "0" + emm;
                }
                let end = edd + "-" + emm + "-" + eyyyy;
                return (
                  <div
                    className={"news"}
                    key={notification.nieuws_id}
                    onClick={() => this.handleNewsClick(notification)}
                    style={{ cursor: "pointer" }}>
                    <div className="newsBubble">
                      <div
                        className={`newsRead ${
                          notification.read === "1" && "read"
                        }`}></div>
                      <span className="newsDate">{end}</span>
                    </div>
                    <div>
                      <div
                        className={`newsTitle ${
                          notification.read === "1" && "read"
                        }`}>
                        {notification.nieuws_title}
                        <ClientBadge
                          clientId={notification.nieuws_vestiging_id}
                        />
                      </div>
                      <div className="text-left newsPreview">
                        {notification.nieuws_body}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <Modal
            isOpen={this.state.modal}
            toggle={() => this.toggle()}
            className="newsModal">
            <ModalHeader toggle={() => this.toggle()}>
              {this.state.selectedNews?.nieuws_title}
            </ModalHeader>
            <ModalBody
              dangerouslySetInnerHTML={
                this.state.selectedNews
                  ? this.createMarkup(
                      (this.state.newsDetails &&
                        this.state.newsDetails.nieuws_body) ||
                        this.state.selectedNews.nieuws_body
                    )
                  : { __html: "" }
              }
            />
            <ModalFooter>
              <Button
                color="danger"
                onClick={() => {
                  this.clickRemove(this.state.selectedNews?.nieuws_id);
                  this.toggle();
                }}>
                Bericht gelezen
              </Button>
              <Button color="secondary" onClick={() => this.toggle()}>
                Sluiten
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </Scrollbars>
    );
  }
}

export default Home;
